import '.cp{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.gz{min-height:200px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.co{align-items:flex-start;}.ssr-plugin'
import '.a3{padding:2rem;}.ssr-plugin'
import '.d6{background:var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.bt{position:absolute;}.ssr-plugin'
import '.j6{top:50%;}.ssr-plugin'
import '.j7{right:1rem;}.ssr-plugin'
import '.j8{transform:translateY(-50%);}.ssr-plugin'
import '.j9{width:120px;}.ssr-plugin'
import '.ja{height:120px;}.ssr-plugin'
import '.jb{z-index:0;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.ih{z-index:1;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.jc{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="cp h gz l m a1 co a3 d6 c"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bt j6 j7 j8 j9 ja jb l aa a1"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="cp ih l m co n jc"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
